<template>
	<div class="bonus__items" v-if="activations?.length">
		<div class="bonus__item card" v-for="(activation) in activations">
			<h5 class="bonus__item-title">
				{{ activation.promocode.amount_title }}
			</h5>

			<div class="bonus__text" v-if="activation.promocode.type === 'balance' || activation.promocode.type === 'balance_referrer'">
				<div>
					Будет начислено на баланс:
					<b>{{ activation.promocode.amount }}</b> ₽
				</div>
				<div>
					Вагер:
					x<b>{{ activation.promocode.wager }}</b>
				</div>
				<div>
					Будет начислено отыгрыша:
					<b>
						{{ activation.promocode.wager * activation.promocode.amount }}
					</b>
				</div>
			</div>

			<div class="bonus__text" v-if="activation.promocode.type === 'deposit' || activation.promocode.type === 'deposit_referrer'">
				<div>
					Будет начислено на баланс:
					<b>{{ (activation.payment.amount / 100) * activation.promocode.amount }}</b> ₽
					(депозит: <b>{{ activation.payment.amount }}</b> ₽)
				</div>
				<div>
					Вагер:
					x<b>{{ activation.promocode.wager }}</b>
				</div>
				<div>
					Будет начислено отыгрыша:
					<b>{{ activation.promocode.wager * ((activation.payment.amount / 100) * activation.promocode.amount) }}</b>
				</div>
			</div>

			<div class="bonus__text" v-if="activation.promocode.type === 'freespin'">
				<div>
					Игра: <b> {{ activation.promocode.freespin?.game?.name }} </b>
				</div>
				<div>
					Вагер: x<b>{{ activation.promocode.wager }}</b>
				</div>
				<div>
					Будет начислено отыгрыша:  <b>Выигрыш</b> x <b>{{ activation.promocode.wager }}</b>
				</div>
			</div>

			<div class="small text-muted">
				Можно активировать до:
				{{ $root.moment(activation.created_at).add(24, 'hours').format('YYYY-MM-DD, HH:mm') }}
			</div>

			<button @click="activate(activation.id)" class="bonus__item-action btn btn--primary btn--block">
				Активировать
			</button>
		</div>
	</div>
</template>

<script>

export default {

	data() {
		return {
			activations: [],
			messageSubs: null
		}
	},
	mounted() {
		this.get();
	},
	created() {
		this.messageSubs = this.$root.emitter.on('promocode.activated', this.get)
	},
	destroyed() {
		this.messageSubs.unsubscribe()
	},
	methods: {
		activate(id) {
			this.$root.axios.post('/api/promocode/activations/activate', {
				'id': id
			})
				.then(res => {
					this.$toast.success(res.data.message);

					this.get();
				}).catch(error => {
				this.$toast.error(this.$root.graphql.axiosGetError(error));
			});
		},
		get() {
			this.$root.axios.get('/api/promocode/activations')
				.then(res => {
					this.activations = res.data.activations;
				}).catch(error => {
				this.$toast.error(this.$root.graphql.axiosGetError(error));
			});
		}
	}
}
</script>